module.exports = __webpack_public_path__ + "media/images/icon__externalLink-86efcc72a7affcf35c4982dc10675573.png";